import Vue from 'vue';
import App from './App.vue';
import router from './router/router';
import store from './store';
import { LanguagePlugin } from './LanguagePlugin';
import { outside } from './directives/outside';
const VueGoogleCharts = require('vue-google-charts');

import '@fortawesome/fontawesome-free/css/all.css';
import 'bulma/css/bulma.css';

Vue.use(LanguagePlugin);
Vue.use(VueGoogleCharts);
Vue.directive('outside', outside);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
